import React from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'shared/events/bub_events';

import { AssetImg } from 'javascripts/components/asset_img';
import { ChirpButton } from 'javascripts/components/chirp_button';

import documentIcon from 'images/document-icon';

import styles from 'stylesheets/components/audiobook/audiobook_supplements_section';

export function AudiobookSupplementsSection({ supplements, hasUserPurchased }) {
  function onViewLinkClicked() {
    bubEvents.track('Audiobook page', 'Bonus material section', {
      label: 'View',
    });
  }

  function renderBonusMaterials() {
    return (
      <>
        {supplements.map(supp => {
          return (
            <div key={supp.displayName} className={styles.bonusMaterial}>
              <AssetImg src={documentIcon} attrs={{ className: styles.documentIcon, alt: '' }} />
              <div>
                <div className={styles.supplementHeader}>
                  <div className={styles.displayTitle}>{supp.displayName}</div>
                  <div className={styles.fileType}>{supp.fileType}</div>
                </div>
                {hasUserPurchased ? (
                  <ChirpButton
                    displayType='link'
                    displayStyle='underline'
                    label='View'
                    fontSize='small'
                    href={supp.filePath}
                    onClick={onViewLinkClicked}
                    attrs={{ target: '_blank', rel: 'noopener' }}
                  />
                ) : (
                  <div>Available after purchase.</div>
                )}
              </div>
            </div>
          );
        })}
      </>
    );
  }

  return <div className={styles.audiobookSupplementsSection}>{renderBonusMaterials()}</div>;
}

AudiobookSupplementsSection.propTypes = {
  hasUserPurchased: PropTypes.bool.isRequired,
  supplements: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      fileType: PropTypes.string.isRequired,
      filePath: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
